import { MoonIcon, SunIcon } from "@chakra-ui/icons";
import {  Badge, Button, Tag, useColorMode } from "@chakra-ui/react";
import './ButtonToggleColorMode.css'

export interface IButtonToggleColorModeProps {}
export default function ButtonToggleColorMode(props: IButtonToggleColorModeProps) {
    const {colorMode, toggleColorMode} = useColorMode()
    return (
        <Button onClick={toggleColorMode} className="button-toggle-mode">
            {colorMode === 'light'?<><MoonIcon/><Badge style={{marginLeft:"5px"}} display={{md:"none"}}>Dark mode</Badge></>:<><SunIcon/><Badge style={{marginLeft:"5px"}} display={{md:"none"}}>Light mode</Badge></>}
        </Button>
    );
}